import { useEffect, useState } from "react";
import { Input } from "../Input/Input";
import { FaTimes } from "react-icons/fa";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

type ForgotPasswordModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (email: string) => void;
  errorMessage?: string | null;
};

const ForgotPasswordModal = ({ isOpen, onClose, onSubmit, errorMessage }: ForgotPasswordModalProps) => {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!isOpen) {
      setEmail("");
    }
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!email.trim()) {
      return;
    }
    onSubmit(email);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal overlayClassName="fixed inset-0 z-50 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center">
      <div className="bg-white rounded-md shadow-xl p-6 relative w-full max-w-3xl">

        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 text-primary-600 hover:text-primary-700 text-2xl font-bold"
        >
          <FaTimes />
        </button>

        <h2 className="text-md md:text-xl font-semibold">{"ESQUECEU SUA SENHA DE ACESSO?"}</h2>

        <p className="text-sm md:text-md mt-5 mb-2">{"Informe seu email de cadastro:"}</p>

        <div className="mb-4">
          <Input
            label={"E-mail"}
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {errorMessage && (
            <p className="text-primary-600 text-sm mt-1">{errorMessage}</p>
          )}
        </div>

        <Button 
          onClick={handleSubmit} 
          className="block mx-auto w-full py-3"
        >
          {"ENVIAR"}
        </Button>
      </div>
    </Modal>
  );
};

export default ForgotPasswordModal;
